import {
  ExtractFnReturnType,
  MutationConfigType,
  useMutation,
  UseMutationResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiManagersEmployeeConditionSurveysMutateRequestType,
  ApiManagersEmployeeConditionSurveysMutateResponseType,
} from "~/domains";

type RequestDataType = {
  id: string;
  employeeConditionSurvey: Omit<
    ApiManagersEmployeeConditionSurveysMutateRequestType,
    "selectedSurveyTemplateId"
  >;
};

const request = async ({
  id,
  employeeConditionSurvey,
}: RequestDataType): Promise<ApiManagersEmployeeConditionSurveysMutateResponseType> => {
  const response =
    await new ApiClient().put<ApiManagersEmployeeConditionSurveysMutateResponseType>(
      `/api/managers/employee_condition_surveys/${id}`,
      { employee_condition_survey: employeeConditionSurvey },
    );
  return response.data;
};

type MutationFnType = typeof request;

type PropsType = {
  config?: MutationConfigType<MutationFnType>;
};

export const useApisManagersEmployeeConditionSurveysUpdate = ({
  config = {},
}: PropsType = {}): UseMutationResult<
  ApiManagersEmployeeConditionSurveysMutateResponseType,
  RequestDataType
> => {
  return useMutation<ExtractFnReturnType<MutationFnType>, RequestDataType>(
    request,
    {
      ...config,
    },
  );
};
